import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import SimpleMDE from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";

const id = window.location.pathname.split('/').pop()
const defaultLayout = Object.keys(DefaultLayout);
const layout = id ? id : defaultLayout

class Crear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            estado: '',
            errores: []
        }
    }

    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }

    handleMDChange = (value) => {
        this.setState({ nombre: value, errores: [] });
    }

    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }

    enviarDatos = (e) => {
        e.preventDefault();
        const { nombre, estado } = this.state;
        var errores = [];
        
        if (!nombre) { errores.push("error_nombre"); }
        if (!estado) { errores.push("error_estado"); }
        
        this.setState({ errores: errores });
        
        if (errores.length > 0) {
            return false;
        }
        
        var datosEnviar = {
            nombre: nombre,
            estado: estado
        }
        
        authAxios.post("marca/registrar", datosEnviar)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'Marca!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterMarca");
                } else {
                    Swal.fire(
                        'Marca!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch()
    }

    // Opciones para SimpleMDE
    getMdeOptions = () => {
        return {
            spellChecker: false,
            autofocus: false,
            placeholder: "Escribe aquí tus observaciones...",
            status: ["lines", "words", "cursor"],
            toolbar: [
                "bold", "italic", "heading", "|",
                "quote", "unordered-list", "ordered-list", "|",
                "link", "image", "|",
                "preview", "side-by-side", "fullscreen", "|",
                "guide"
            ],
            minHeight: "300px",
        };
    }

    render() {
        const { nombre, estado } = this.state;
        
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRAR MARCA DE VEHICULO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="nombre">Observaciones </label>
                                                    
                                                    {/* SimpleMDE Editor */}
                                                    <SimpleMDE 
                                                        options={this.getMdeOptions()}
                                                    />
                                                    
                                                    {this.verificarError("error_nombre") && (
                                                        <div className="text-danger">
                                                            <small>Las observaciones son obligatorias</small>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm">
                                                    <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear marca
                                                </button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/marca/lista/${layout}`}>
                                                    <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;